import { render, staticRenderFns } from "./TwoFA.vue?vue&type=template&id=f074a1f0&"
import script from "./TwoFA.vue?vue&type=script&lang=js&"
export * from "./TwoFA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports